import React, { useEffect, useState } from "react";
import { ReactComponent as MagnifiyingGlass } from "../../../assets/navbar/MagnifyingGlass.svg";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import { fetchAllUsers, deleteUserProfile, deleteUserProfileLocal } from "../../../redux/actions/userActions";
// import { removeU } from "../../../redux/actions/userActions";
import ComponentLoading from "../../../commonComponents/ComponentLoading";
import Modal from "react-modal";
import { ReactComponent as Cross } from "../../../assets/analyse/Cross.svg";
import MainButton from "../../../commonComponents/MainButton";
import { auth } from "../../../firebase/config";

const UsersList = ({ setAddMenu, set_is_modify_user, set_to_modify }) => {
  // REDUX
  const dispatch = useDispatch();
  const fetchAllUsers_rd = (item) => dispatch(fetchAllUsers(item));
  const deleteUserProfile_rd = (item) => dispatch(deleteUserProfile(item));
  const deleteUserProfileLocal_rd = (item) => dispatch(deleteUserProfileLocal(item));
  const fetched_users = useSelector((state) => (state.user.fetched_users ? state.user.fetched_users : []));
  const add_user_profile_status = useSelector((state) => state.user.add_user_profile_status);
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  useEffect(() => {
    const fetch_fun = async () => {
      await fetchAllUsers_rd();
    };
    fetch_fun();
  }, []);

  const [isDelete, setIsDelete] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  const handleChangeRemoveUser = async () => {
    const item = {
      user_id: toDelete.id,
      organization_id: user_info.organization_info.id,
      tenant_id: user_info.organization_info.tenant_id,
    };
    await deleteUserProfile_rd(item);
    await deleteUserProfileLocal_rd(item);
    setIsDelete(false);
    // set_rand_update(Math.random());
  };

  return (
    <>
      <div className="w-full flex justify-center items-center h-[60px]">
        <div className="w-[900px] h-full border-b-[1px] border-black">
          <div className="flex h-full justify-between items-center">
            <div className="h-full flex items-center">
              <input className="w-[450px] mx-10 rounded-md bg-[#F8FAFB] font-PoppinsLignt text-sm h-[35px] pl-[60px]" type="text" placeholder="Recherche un produit, un procédé, une étape..." />
              <MagnifiyingGlass fill="#7e84a3" className="absolute ml-[60px]" />
            </div>
            <button
              className="w-[180px] h-[40px] rounded-lg bg-mainGreen text-white font-Poppins-SemiBold text-sm"
              onClick={async () => {
                setAddMenu(1);
              }}
            >
              Ajouter un membre
            </button>
          </div>
        </div>
      </div>

      {/* <div className="w-full flex justify-center"> */}
      <div className="w-full px-[48px] mt-[30px] flex max-h-[360px] justify-center overflow-auto">
        {fetched_users.length > 0 ? (
          // <div class="table-wrp block h-[200px]">
          <table className="w-full flex-row h-full">
            <thead class="sticky top-0">
              <tr className="bg-gray-200 text-gray-600 uppercase text-sm leiadng-normal">
                <th className="py-3 px-6 text-left">Membres</th>
                <th className="py-3 px-6 text-left">Rôle</th>
                <th className="py-3 px-6 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light overflow-y-auto ">
              {fetched_users.map((current, i) => {
                return (
                  <tr className="border-b border-gray-200 hover:bg-gray-100">
                    <td className="py-3 px-6 text-center">
                      <div className="flex items-center justify-left">
                        <div className="flex justify-center">
                          <div
                            className={
                              (current.id === auth.currentUser.uid ? "border-[1.5px] border-mainGreen" : "") + " bg-[#57B8FF] w-10 h-10 rounded-full flex justify-center items-center text-white"
                            }
                          >
                            {current.data.user_info.email.slice(0, 2).toUpperCase()}
                          </div>

                          <div className=" ml-[20px]">
                            <p className="text-xs font-Poppins-SemiBold text-black text-left">{current.data.user_info.name}</p>
                            <p className="text-xs font-Poppins-Regular text-gray-500/50 text-left">{current.data.user_info.email}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="py-3 px-6 text-left whitespace-nowrap">
                      <div className="flex items-center">
                        <span className="font-Poppins-SemiBold">{current.data.organization_info.role.name}</span>
                      </div>
                    </td>

                    <td className="py-3 px-6 text-center">
                      <div className="flex item-center justify-center">
                        {/* <div className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          </div> */}
                        {user_info.organization_info.role.name === "Administrateur" && current.id !== auth.currentUser.uid && (
                          <div
                            onClick={() => {
                              setAddMenu(1);
                              set_is_modify_user(true);
                              set_to_modify(current);
                            }}
                            className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          </div>
                        )}

                        {user_info.organization_info.role.name === "Administrateur" && current.id !== auth.currentUser.uid && (
                          <div
                            onClick={() => {
                              console.log("DELTE", current.id !== auth.currentUser.uid);
                              setToDelete(current);
                              setIsDelete(true);
                            }}
                            className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          // </div>
          <>
            <table className="min-w-max w-full table-auto">
              <thead>
                <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                  <th className="py-3 px-6 text-left">Membres</th>
                  <th className="py-3 px-6 text-left">Rôle</th>
                  <th className="py-3 px-6 text-center">Actions</th>
                </tr>
              </thead>
            </table>
            <ComponentLoading height={35} style={"h-full w-[full] mt-[60px] flex items-center  justify-center"} />
          </>
        )}
      </div>
      {/* </div> */}

      <Modal
        isOpen={isDelete}
        onBackdropPress={() => setIsDelete(false)}
        style={{
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 330,
            width: 580,
            borderRadius: 20,
            borderWidth: 0,
            boxShadow: "0px 0px 2px #9E9E9E",
          },
        }}
      >
        <div className=" h-full grid justify-items-center">
          <p className="font-Poppins-SemiBold text-4xl flex text-center mt-[50px]">Supprimer l'utilisateur</p>
          <div className="flex flex-row align-baseline mt-[-30px]">
            <p className="font-Poppins-Light text-2xl flex text-center">{toDelete && toDelete.data.user_info.email}</p>
            <p className="font-Poppins-SemiBold text-4xl flex text-center ml-[2px]"> ?</p>
          </div>
          <div className="cursor-pointer absolute right-2">
            <Cross height={20} onClick={() => setIsDelete(false)} />
          </div>
          <div class="flex items-center w-[200px] justify-center h-[40px] mt-[-20px]">
            <MainButton disabled={true} callback={async () => await handleChangeRemoveUser()} title={"Supprimer"} styleWind={"text-xs px-[10px]"} />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UsersList;
